import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../utils/api';
import './BookingDetailPage.css';

const BookingDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const res = await api.get(`/bookings/${id}`);
        setBooking(res.data);
      } catch (error) {
        console.error('Failed to fetch booking:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBooking();
  }, [id]);

  const handleStatusChange = async (newStatus) => {
    try {
      const res = await api.patch(`/bookings/${id}/status`, { status: newStatus });
      setBooking(res.data);
    } catch (error) {
      console.error('Failed to update status:', error);
    }
  };

  if (loading) {
    return <AdminLayout><div className="admin-loading">Loading...</div></AdminLayout>;
  }

  if (!booking) {
    return <AdminLayout><div className="admin-loading">Booking not found</div></AdminLayout>;
  }

  return (
    <AdminLayout>
      <div className="booking-detail-page">
        <button className="back-btn" onClick={() => navigate('/admin/bookings')}>
          ← Back to Bookings
        </button>
        <div className="detail-header">
          <h1>{booking.bookingCode}</h1>
          <span className={`status-badge ${booking.status.toLowerCase()}`}>{booking.status}</span>
          {booking.inPreparation && (
            <span className="preparation-badge">준비중 예약</span>
          )}
        </div>
        {booking.inPreparation && (
          <div className="preparation-notice">
            ⚠️ 이 예약은 <strong>서비스 준비중</strong> 상태에서 접수된 건으로, 확정 예약이 아닙니다.
          </div>
        )}

        <div className="detail-grid">
          <div className="detail-card">
            <h3>Booking Info</h3>
            <div className="detail-row"><span>Location</span><span>{booking.locationId}</span></div>
            <div className="detail-row"><span>Course</span><span>{booking.courseId}</span></div>
            <div className="detail-row"><span>Duration</span><span>{booking.duration} min</span></div>
            <div className="detail-row"><span>Price</span><span>{booking.price?.toLocaleString()} ฿</span></div>
            <div className="detail-row"><span>Date</span><span>{booking.bookingDate}</span></div>
            <div className="detail-row"><span>Time</span><span>{booking.bookingTime}</span></div>
            <div className="detail-row"><span>Therapist ID</span><span>{booking.therapistId}</span></div>
          </div>

          <div className="detail-card">
            <h3>Customer Info</h3>
            <div className="detail-row"><span>Name</span><span>{booking.contactName}</span></div>
            <div className="detail-row"><span>Phone</span><span>{booking.contactPhone}</span></div>
            <div className="detail-row"><span>Email</span><span>{booking.contactEmail}</span></div>
            {booking.contactNote && (
              <div className="detail-row"><span>Note</span><span>{booking.contactNote}</span></div>
            )}
            {booking.healthConditions && (
              <div className="detail-row health-conditions-row">
                <span>Health Conditions</span>
                <span className="health-conditions-value">⚠️ {booking.healthConditions}</span>
              </div>
            )}
          </div>

          <div className="detail-card">
            <h3>Payment</h3>
            {booking.payment ? (
              <>
                <div className="detail-row"><span>Amount</span><span>{booking.payment.amount?.toLocaleString()} {booking.payment.currency}</span></div>
                <div className="detail-row"><span>Status</span><span className={`status-badge ${booking.payment.status.toLowerCase()}`}>{booking.payment.status}</span></div>
                <div className="detail-row"><span>Method</span><span>{booking.payment.paymentMethod || '-'}</span></div>
              </>
            ) : (
              <p className="no-data">No payment info</p>
            )}
          </div>

          <div className="detail-card">
            <h3>Actions</h3>
            <div className="action-buttons">
              <button className="action-btn confirm" onClick={() => handleStatusChange('CONFIRMED')} disabled={booking.status === 'CONFIRMED'}>Confirm</button>
              <button className="action-btn complete" onClick={() => handleStatusChange('COMPLETED')} disabled={booking.status === 'COMPLETED'}>Complete</button>
              <button className="action-btn cancel" onClick={() => handleStatusChange('CANCELLED')} disabled={booking.status === 'CANCELLED'}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default BookingDetailPage;
